import $ from 'jquery';
import 'bootstrap';

import calendario from '../../views/componente-calendario/calendario';
import treColonneSlider from '../../views/componente-tre-colonne-slider/tre-colonne-slider';
import menuAccordion from '../../views/menu/menu-accordion';
import header from '../../views/header/header';
import loading from '../../views/loading/loading';
import navMenu from './nav-menu';
import share from '../../views/share/share';
import mosaicoEsagoni from '../../views/componente-mosaico-esagoni/mosaico-esagoni';

(function () {
  $(window).on('load', function () {
    loading();
    calendario();
    treColonneSlider();
    menuAccordion();
    header();
    navMenu();
    share();
    mosaicoEsagoni();

    $(window).on('scroll', function () {
      var scroll = $(window).scrollTop();
      if (scroll > 300) {
        $('.banner-disclaimer').addClass('hide');
      } else {
        // $('.banner-disclaimer').removeClass('hide');
      }
    });

  });
})($);



// WEBPACK FOOTER //
// ./scripts/main.js